import React from 'react';
import './button.css'

const STYLES = [
    'btn--primary',
    'btn--secondary',
    'btn--danger',
    'btn--outline'
]

const SIZES = [
    'btn--small',
    'btn--medium',
    'btn--large'
]

export const Button = ({
    children,
    type,
    onClick,
    buttonStyle,
    buttonSize,
    disabled,
    className
}) => {
    const checkButtonStyle = STYLES.includes(buttonStyle) ? buttonStyle : STYLES[0]
    const checkButtonSize = SIZES.includes(buttonSize) ? buttonSize : SIZES[1]

    return (
        <button
            className={`btn ${checkButtonStyle} ${checkButtonSize} ${className || ''}`}
            onClick={onClick}
            type={type}
            disabled={disabled}
        >
            {children}
        </button>
    )
}